module.exports = __webpack_public_path__ + "039c1e756ba9bf5ef39d52f2bd75881d.png";